import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.prototype.$AccessAuthBase64Prefix = "Access#base64`Thaigreen@2024:";

Vue.prototype.$tabpaneVar = [
   { key: "staff-index", value: "/staff/index" },
   { key: "staff-department", value: "/staff/department" },
   { key: "staff-staffpost", value: "/staff/staffpost" },
   { key: "staff-role", value: "/staff/role" },
   { key: "staff-salary", value: "/staff/salary" },
   { key: "staff-kaoqin", value: "/staff/kaoqin" },
   { key: "staff-chufa", value: "/staff/chufa" }
];

// 设置页面标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '巡对讲'; // 可以在路由的 meta 中设置标题
  next();
});

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})